<template>
  <GlButton
    class="gradient-animation"
    gradient
    :size="size"
    :title="buyButtonContent.label"
    @click="onBuyClick(currentPlan)"
  >
    <template
      v-if="buyButtonContent.iconName"
      #beforeTitle
    >
      <gl-icon
        :height="24"
        :name="buyButtonContent.iconName"
        white
        :width="24"
      />
    </template>
  </GlButton>
</template>

<script>
// components
import GlButton from '@/components/gl-button'
import GlIcon from '@/components/gl-icon'
// utils
import { openProfilePlan } from '@/utils/go-to-route'
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'BuyButton',
  components: {
    GlButton,
    GlIcon,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    ...mapGetters('user', ['isLogin']),
    ...mapGetters('payment', ['getPlans']),
    currentPlan() {
      return this.getPlans.find(p => p.type == this.type)
    },
    buyButtonContent() {
      if (!this.isLogin) {
        return {
          label: `Log In to Unlock`,
        }
      }
      return {
        iconName: 'I-Upgrade-Plan',
        label: `Upgrade to ${this.currentPlan?.title}`,
      }
    },
  },
  methods: {
    openProfilePlan,
    onBuyClick(item) {
      const currentPath = this.$route.fullPath
      localStorage.setItem('comeBackPath', currentPath)
      this.openProfilePlan({
        planTier: item.tier,
        billingCycle: 'annual',
        isTrialRequest: false,
      })
    },
  },
}
</script>


